import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SalesPerformanceDataService {
  private salesPerformanceSubject = new BehaviorSubject<any>({
    byVolume: [],
    bySqft: []
  });
  public salesPerformance$ = this.salesPerformanceSubject.asObservable();

  updateSalesPerformance(data: any): void {
    const current = this.salesPerformanceSubject.value;
    const item = {
      rank: data.rank,
      percentile: data.percentile,
      status: data.rankingDescriptor,
      description: this.getComparisonDescription(data.comparison),
      color: data.color,
      chartData: data.chartData
    };

    const comparisonKey = this.getComparisonKey(data.comparison);
    
    if (data.comparison?.keyIndicator === 'SALES_VOLUME') {
      const existingIndex = current.byVolume.findIndex(i => this.getComparisonKey(i.chartData?.comparison) === comparisonKey);
      if (existingIndex >= 0) {
        current.byVolume[existingIndex] = item;
      } else {
        current.byVolume.push(item);
      }
    } else if (data.comparison?.keyIndicator === 'SALES_SQFT') {
      const existingIndex = current.bySqft.findIndex(i => this.getComparisonKey(i.chartData?.comparison) === comparisonKey);
      if (existingIndex >= 0) {
        current.bySqft[existingIndex] = item;
      } else {
        current.bySqft.push(item);
      }
    }

    this.salesPerformanceSubject.next({ ...current });
  }

  private getComparisonKey(comparison: any): string {
    if (!comparison) return 'unknown';
    return `${comparison.keyIndicator}_${comparison.region}_${comparison.comparisonType}`;
  }

  private getComparisonDescription(comparison: any): string {
    if (!comparison) return 'vs All in Market Area';
    
    const regionType = comparison.region || comparison.regionType;
    const comparisonType = comparison.comparisonType;
    
    if (regionType === 'DRIVE_TIME') {
      return 'vs All in 7-Minute Drive Time';
    } else if (regionType === 'MARKET_AREA') {
      if (comparisonType === 'BANNER') {
        return 'vs Same Banner in Market Area';
      }
      return 'vs All in Market Area';
    }
    
    return 'vs All in Market Area';
  }

  getSalesPerformance(): any {
    return this.salesPerformanceSubject.value;
  }
}